/**
 * Utility functions for branding configuration
 */

/**
 * Get the current hostname
 * @returns The current hostname or 'localhost' during development
 */
export const hostname = (): string => {
  return window.location.hostname;
};
